"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLinkLabel = void 0;
/** Returns label for an article button link based on article params.
 * if `link.title` is specified, it returns `link.title.
 * Otherwise returns `labelWatch` for video article or `labelRead` for other option.
 *
 * @returns string, label for an article button link.
 */
const getLinkLabel = ({
  isVideoArticle,
  labelRead,
  labelWatch,
  link
}) => {
  if (link?.title) {
    return link.title;
  }
  return isVideoArticle ? labelWatch : labelRead;
};
exports.getLinkLabel = getLinkLabel;
